import { hitsApi } from '../../../api';
import type { RecordHitInput, HitResult } from '../../../types';
import type { GameStateGetter } from '../types';

export const createRecordHit = (get: GameStateGetter) => {
  return async (boardId: string, input: RecordHitInput): Promise<HitResult> => {
    const result = await hitsApi.record(boardId, input);
    await get().fetchHits(boardId);
    return result;
  };
};
